import utagLinkGeneric from './utagLinkGeneric';

function utagLinkSFP (eventCategory = 'SFP') {

	return ({ eventAction, eventLabel = '', nonInteraction = 0 }) => {

		utagLinkGeneric({
			eventCategory,
			eventAction,
			eventLabel,
			nonInteraction
		});

	};

}

export default utagLinkSFP;
